import styled from "styled-components";





const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

interface StyledCheckBoxProps {
  $small;
}

const StyledCheckbox = styled.input<StyledCheckBoxProps>`
  width: ${(props) => props.$small ? 16 : 18 }px;
  height: ${(props) => props.$small ? 16 : 18 }px;;
  margin-right: 10px;
  accent-color: var(--primary);
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    outline: 1px solid var(--primary);
    border-radius: 0.125rem;
  }

`;

const Label = styled.label`
  font-size: 1em;
  color: var(--text-color);

  a {
    color: var(--link-color);
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: var(--text-color);
    }
  }
`;

const Checkbox = ({
  id,
  checked,
  onChange,
  label,
  small = false
}) => {

  return (
    <CheckboxWrapper>
      <StyledCheckbox
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.value)}
        id={id}
        $small={small}
      />
      <Label htmlFor={id}>{label}</Label>
    </CheckboxWrapper>
  );
};

export default Checkbox;
